<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="paymentsCustomerLimit"
				:flag="flag"
				page-title="Customer payments"
				:headers="headers"
				:settings="getSettings"
				:filtersList="paymentsCustomerFilters"
				:list="paymentsCustomerList"
				:defaultOrder="paymentsCustomerOrder"
				:defaultSort="paymentsCustomerSort"
				:totals="paymentsCustomerTotals"
				:total-pages="paymentsCustomerTotal"
				:limit-pages="paymentsCustomerLimit"
				:pages="[ 15, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				:is-create="false"
				is-settings
		></main-table-all-back>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('payments-customer')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<preview-doc v-if="link" @clear-link="clearLink" :link-doc="link"></preview-doc>

	</div>
</template>
<script>
import Vuex, { mapActions, mapGetters } from "vuex";
import CustomerPayments from "@/store/modules/accounting/customer-payments/customer-payments.module";
import PreviewDoc from "@/modules/invoices/preview";
// services
import settingsMixins from "@/mixins/settingsMixins";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import { PAGE } from "@/constants/constants";

const store = new Vuex.Store();
store.registerModule("CustomerPayments", CustomerPayments);
const TableSettings = () => import("@/shared/TableSettings/TableSettings");

export default {
	mixins: [ settingsMixins ],
	components: {
		DialogRemove,
		MainTableAllBack,
		PreviewDoc,
		TableSettings,
	},
	computed: {
		...mapGetters([
			'paymentsCustomerList',
			'paymentsCustomerLimit',
			'paymentsCustomerOrder',
			'paymentsCustomerSort',
			'paymentsCustomerTotal',
			'paymentsCustomerTotals',
			'paymentsCustomerFilters',

		]),
		actionList: {
			get: function() {
				return this.list;
			},
			set: function(val) {
				this.list = val.reverse();
			},
		}
	},
	data() {
		return {
			flag: PAGE.PAYMENTS_CUSTOMER,
			snackbar: false,
			list: [],
			link: undefined,
			show: false,
			itemRemove: null,
			editedItem: {
				amount: null,
				customer: null,
				date: null,
				note: null,
				id: null,
			},
			lengthList: 0,
			updateTable: false,
			isTableSettingsDrawer: false,
			uniqId: null,

			isDialogRemove: false,
			titleRemove: null,
			textRemove: null,
			activeItem: null,
			defaultFilter: null,
			activeTableFilters: null,
		};
	},
	methods: {
		...mapActions([
			'getPaymentsCustomer',
			'getPaymentsCustomerFilters',
			'actionPreloader',
			'getDeletePayment',
			'onExportLink',
		]),

		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getPaymentsCustomer(filters);
			if (!isWithoutFilters) await this.getPaymentsCustomerFilters(filters);
		},

		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getPaymentsCustomer(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},

		onClickButton({ key, item }) {
			this.activeItem = item;
			if ( key === 'delete' ) {
				const title = TITLE.REMOVE_CUSTOMER_PAYMENTS;
				const text = TEXT.REMOVE_CUSTOMER_PAYMENTS;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			const { id } = this.activeItem;
			await this.getDeletePayment(id);
			this.onCloseRemove();
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'payments-customer' });
		},
	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>
<style lang="scss" scoped>
@import "./customer-payments.component";
</style>
